import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { HomeSidebarService } from '@services/home-sidebar.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/auth/services/auth.service';
import { SideMenu } from 'src/app/models';
import { SeletorProjetosService } from '../seletor-projetos/seletor-projetos.service';
import { SidebarLinksService } from '../sidebar-links.service';
/*
    Declaração do Jquery
*/
declare var $: any;

@Component({
    selector: 'app-home-sidebar',
    templateUrl: './home-sidebar.component.html',
    styleUrls: ['./home-sidebar.component.css'],
    providers: [NgbDropdownConfig],
})
export class HomeSidebarComponent implements OnInit, OnDestroy {
    sidebar_active;
    colaborador;
    links: SideMenu[] = [];
    linksAtualizados;
    sidebar$;

    constructor(
        private apiSidebar: HomeSidebarService,
        public authService: AuthService,
        private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        public sidebarLinksService: SidebarLinksService,
        private seletorProjetosService: SeletorProjetosService,
        config: NgbDropdownConfig
    ) {
        config.placement = 'bottom-left';
    }

    ngOnInit() {
        this.sidebarLinksService.links$.subscribe(
            links => (this.links = links)
        );
        this.seletorProjetosService.projeto$.subscribe(projeto => {
            if (!projeto) {
                return;
            }
            const linkReq = this.links.find(el => el.id === 'requisicoes');
            if (linkReq === undefined) return;
            const query = linkReq.submenus.find(
                el => el.id === 'requisicoes-autorizar'
            ).query;
            if (query === undefined) return;
            query.titulo_curto = projeto.titulo_curto;
        });
        this.sidebar$ = this.apiSidebar
            .getStatus()
            .subscribe(status => (this.sidebar_active = status));

        this.spinner.show('sidebar');
        this.authService.getDadosLogin().subscribe(res => {
            if (res) {
                this.colaborador = res['dados'];
                this.spinner.hide('sidebar');
            } else {
                this.toastr.info('Dados do Login não foram carregados');
                this.toastr.info('Carregando Sidebar...');
            }
        });
    }

    ngAfterViewInit(): void {
        $('#collapseGroup').on(
            'show.bs.collapse',
            '.collapse',
            (event: any) => {
                const mainNavigation = $(event.target).prev(
                    'a[data-menu="main"]'
                );
                if (mainNavigation.length) {
                    $('#collapseGroup .collapse')
                        .not(event.target)
                        .collapse('hide');
                }
            }
        );
    }

    onSelect() {
        this.apiSidebar.updateStatus(false);
    }

    ngOnDestroy() {
        this.sidebar$.unsubscribe();
    }
}
